import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { searchTranslationRef } from '@backstage/plugin-search';
import { searchReactTranslationRef } from '@backstage/plugin-search-react';

/**
 * Every Search plugin text in pt-BR (Story 2.2): the result-type picker and
 * the search modal, in case another page still renders them.
 */
export const searchMessages = TranslationBlueprint.make({
  name: 'byx-search',
  params: {
    resource: createTranslationMessages({
      ref: searchTranslationRef,
      messages: {
        'searchModal.viewFullResults': 'Ver todos os resultados',
        'searchType.allResults': 'Todos os resultados',
        'searchType.tabs.allTitle': 'Todos',
        'searchType.accordion.allTitle': 'Todos',
        'searchType.accordion.collapse': 'Recolher',
        'searchType.accordion.numberOfResults': '{{number}} resultados',
        'sidebarSearchModal.title': 'Busca',
      },
    }),
  },
});

/** Every search-react text: search bar, filters, pagination, pager. */
export const searchReactMessages = TranslationBlueprint.make({
  name: 'byx-search-react',
  params: {
    resource: createTranslationMessages({
      ref: searchReactTranslationRef,
      messages: {
        'searchBar.title': 'Busca',
        'searchBar.placeholder': 'Buscar em {{org}}',
        'searchBar.clearButtonTitle': 'Limpar',
        'searchFilter.allOptionTitle': 'Todos',
        'searchPagination.limitLabel': 'Resultados por página:',
        'searchPagination.limitText': 'de {{num}}',
        noResultsDescription: 'Nenhum resultado encontrado.',
        'searchResultGroup.linkTitle': 'Ver todos',
        'searchResultGroup.addFilterButtonTitle': 'Adicionar filtro',
        'searchResultPager.previous': 'Anterior',
        'searchResultPager.next': 'Próxima',
      },
    }),
  },
});
